export const site = {
  name: 'Adriatic Masterpiece Residence',
  shortName: 'AMR',
  location: 'Vukice Mitrović, 85315 Sveti Stefan, Montenegro',
  mapUrl: 'https://www.google.com/maps/search/?api=1&query=Adriatic+Masterpiece+Residence+Sveti+Stefan',
  mapEmbedUrl: 'https://www.google.com/maps?q=Adriatic%20Masterpiece%20Residence%2C%20Sveti%20Stefan%2C%20Montenegro&z=16&output=embed',
  booking: 'https://www.booking.com/hotel/me/adriatic-masterpiece-residence-1.html',
};
